import React from 'react';
function CornerRadius({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      {' '}
      <path
        strokeLinejoin="round"
        d="M2.5 7.5v-2a3 3 0 0 1 3-3h2m-5 10v2a3 3 0 0 0 3 3h2m5 0h2a3 3 0 0 0 3-3v-2m0-5v-2a3 3 0 0 0-3-3h-2"
      />{' '}
    </svg>
  );
}

export default CornerRadius;
